import * as Sentry from '@sentry/browser';
import { Integrations as ApmIntegrations } from '@sentry/apm';

const getEnvironment = () => {
  switch (window.location.host) {
    case 'ir.oms.no':
      return 'Production';
    case 'ir-test.oms.no':
      return 'Test';
    case 'ir.apps.dev.oms.no':
      return 'Dev';
    default:
      return null;
  }
};

/*
function getReleaseVersion() {
  const { releaseVersion } = require('./meta.json') || {};
  return releaseVersion;
}
*/

export function setupSentry() {
  if (process.env.NODE_ENV === 'production') {
    Sentry.init({
      dsn:
        'https://c9cf1171186e4b4588e5265d8d7cf8c2@o352519.ingest.sentry.io/5270241',
      sampleRate: 0.25,
      environment: getEnvironment(),
      // release: getReleaseVersion(),
      integrations: [new ApmIntegrations.Tracing()],
      tracesSampleRate: 0.25,
    });
  }
}
